import React from 'react';

interface SuccessProps {
  className?: string;
  width?: number;
  height?: number;
}

const SuccessIcon = function SuccessIcon({
  className,
  width,
  height,
}: SuccessProps): JSX.Element {
  return (
    <div style={{ textAlign: 'center' }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        width={width}
        height={height}
        viewBox="0 0 85 85"
        fill="none"
      >
        <circle cx="42.5" cy="42.5" r="31.875" fill="#00B54A" fillOpacity="0.6" />
        <circle cx="42.5" cy="42.5" r="31.875" stroke="#00B54A" strokeWidth="1.2" />
        <path
          d="M56.6665 35.4165L40.3602 54.9841C39.7046 55.7707 39.3769 56.1641 38.9363 56.1841C38.4957 56.204 38.1337 55.842 37.4096 55.1179L28.3332 46.0415"
          stroke="white"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
      </svg>
    </div>

  );
};

SuccessIcon.defaultProps = {
  className: '',
  width: 90,
  height: 90,
};

export default SuccessIcon;
